import React from 'react';

export const AsanaSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-67.5"
				y="-263.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#F06A6A" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.2735 16.5076C19.0314 16.5076 17.2139 18.3252 17.2139 20.5674C17.2139 22.8095 19.0314 24.6271 21.2735 24.6271C23.5156 24.6271 25.3332 22.8095 25.3332 20.5674C25.3332 18.3252 23.5156 16.5076 21.2735 16.5076ZM10.7262 16.5079C8.4841 16.5079 6.6665 18.3252 6.6665 20.5674C6.6665 22.8095 8.4841 24.6271 10.7262 24.6271C12.9683 24.6271 14.786 22.8095 14.786 20.5674C14.786 18.3252 12.9683 16.5079 10.7262 16.5079ZM20.0594 11.4329C20.0594 13.6751 18.2419 15.4929 15.9999 15.4929C13.7577 15.4929 11.94 13.6751 11.94 11.4329C11.94 9.19071 13.7577 7.37305 15.9999 7.37305C18.2419 7.37305 20.0594 9.19071 20.0594 11.4329Z"
				fill="white"
			/>
		</svg>
	);
};
